import React from 'react';
import Logo from '@images/brand/rp-icon.svg';

interface Props {
	isVisible: boolean;
}

const DomainTransitionLoader: React.FC<Props> = ({ isVisible }) => {
	if (!isVisible) return null;

	return (
		<div className="fixed inset-0 z-50 bg-white bg-opacity-90 backdrop-blur-sm">
			<div className="flex items-center justify-center h-full">
				<div className="text-center">
					<div className="relative">
						<Logo className="h-16 w-16 mx-auto animate-pulse" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default DomainTransitionLoader;
